import { useEffect, useState } from "react";
import Checkbox, { CheckboxChangeEvent } from "antd/lib/checkbox";

interface FilterCheckboxProps {
    fieldName: 'isInStock' | 'isExisted' | 'hasGoodsDayPhoto';
    checked?: boolean;
    label: string;
    dispatchGridFilter: (action: any) => void;
}

export const FilterCheckbox: React.FC<FilterCheckboxProps> = ({ fieldName, checked, label, dispatchGridFilter }) => {

    const [isChecked, setIsChecked] = useState(checked);
    
    useEffect(() => {
        setIsChecked(checked);
    }, [checked]);

    useEffect(() => {
        if (checked) {
            dispatchGridFilter({
                type: 'addColumnFilter',
                payload: {
                    name: fieldName,
                    operator: 'Eq',
                    value: true
                },
            });
        }
    }, []);

    const handleChange = (e: CheckboxChangeEvent) => {
        const newChecked = e.target.checked;
        setIsChecked(newChecked);
        
        if (newChecked) {
            dispatchGridFilter({
                type: 'addColumnFilter',
                payload: {
                    name: fieldName,
                    operator: 'Eq',
                    value: true
                },
            });
        } else {
            dispatchGridFilter({ type: "deleteColumnFilter", payload: fieldName });
        }
    };
    
    return (
        <Checkbox
            checked={isChecked}
            onChange={handleChange}
        >
            {label}
        </Checkbox>
    );
};